<template>
    <div class="wrapSQ">
        <!--轮播图-->
        <eazyswiper :type="5"></eazyswiper>
        <div class="content flex-row">
            <!--简介-->
            <div class="item-box clearfix">
                <div class="item-title flex-row">
                    <h2>{{ $store.state.navlist[51] }}</h2>
                    <a
                        href="javascript:void(0);"
                        @click="
                            goDetail(
                                itemDataOne,
                                $store.state.navlist[5],
                                $store.state.navlist[51]
                            )
                        "
                        class="titleA"
                        >详情&gt;&gt;</a
                    >
                </div>
                <!--公用线-->
                <div
                    @click="
                        goDetail(
                            itemDataOne,
                            $store.state.navlist[5],
                            $store.state.navlist[51]
                        )
                    "
                    class="item-tw-img"
                >
                    <img :src="itemDataOne.image" :alt="itemDataOne.title" />
                </div>
                <div class="item-tw-text">
                    {{
                        itemDataOne.introduction &&
                        itemDataOne.introduction.length > 120
                            ? itemDataOne.introduction.substring(0, 120) + "..."
                            : itemDataOne.introduction
                    }}
                </div>
            </div>
			  <!-- 政策法规 -->
			<div class="item-box">
			    <div class="item-title flex-row">
			        <h2>{{ $store.state.navlist[52] }}</h2>
			        <a
			            href="javascript:void(0);"
			            class="titleA"
			            @click="
			                goList(
			                    52,
			                    $store.state.navlist[5],
			                    $store.state.navlist[52]
			                )
			            "
			            >更多&gt;&gt;</a
			        >
			    </div>
			    <div
			        @click="
			            goDetail(
			                item,
			                $store.state.navlist[5] +
			                    '<' +
			                    $store.state.navlist[52]
			            )
			        "
			        v-for="(item, index) in itemDataFive"
			        :key="index"
			        class="zixun-item flex-row"
			    >
			        <span class="zixun-title">{{ item.title }}</span>
			        <span class="zixun-item-time">{{
			            item.creaTime.time | dateFormat
			        }}</span>
			    </div>
			</div>
			    <!-- 实用技术培训 -->
			<div class="item-box">
			    <div class="item-title flex-row">
			        <h2>{{ $store.state.navlist[53] }}</h2>
			        <a
			            href="javascript:void(0);"
			            class="titleA"
			            @click="
			                goList(
			                    53,
			                    $store.state.navlist[5],
			                    $store.state.navlist[53]
			                )
			            "
			            >更多&gt;&gt;</a
			        >
			    </div>
			    <div
			        @click="
			            goDetail(
			                item,
			                $store.state.navlist[5] +
			                    '<' +
			                    $store.state.navlist[53]
			            )
			        "
			        v-for="(item, index) in itemDataThree"
			        :key="index"
			        class="zixun-item flex-row"
			    >
			        <span class="zixun-title">{{ item.title }}</span>
			        <span class="zixun-item-time">{{
			            item.creaTime.time | dateFormat
			        }}</span>
			    </div>
			</div>
			 <!-- 农民中专 -->
			<div class="item-box">
			    <div class="item-title flex-row">
			        <h2>{{ $store.state.navlist[54] }}</h2>
			        <a
			            href="javascript:void(0);"
			            class="titleA"
			            @click="
			                goList(
			                    54,
			                    $store.state.navlist[5],
			                    $store.state.navlist[54]
			                )
			            "
			            >更多&gt;&gt;</a
			        >
			    </div>
			    <div
			        @click="
			            goDetail(
			                item,
			                $store.state.navlist[5] +
			                    '<' +
			                    $store.state.navlist[54]
			            )
			        "
			        v-for="(item, index) in itemDataFour"
			        :key="index"
			        class="zixun-item flex-row"
			    >
			        <span class="zixun-title">{{ item.title }}</span>
			        <span class="zixun-item-time">{{
			            item.creaTime.time | dateFormat
			        }}</span>
			    </div>
			</div>
			 <!-- 镇村活动 -->
			<div class="item-box">
			    <div class="item-title flex-row">
			        <h2>{{ $store.state.navlist[55] }}</h2>
			        <a
			            href="javascript:void(0);"
			            class="titleA"
			            @click="
			                goList(
			                    55,
			                    $store.state.navlist[5],
			                    $store.state.navlist[55]
			                )
			            "
			            >更多&gt;&gt;</a
			        >
			    </div>
			    <div
			        @click="
			            goDetail(
			                item,
			                $store.state.navlist[5] +
			                    '<' +
			                    $store.state.navlist[55]
			            )
			        "
			        v-for="(item, index) in itemDataSix"
			        :key="index"
			        class="zixun-item flex-row"
			    >
			        <span class="zixun-title">{{ item.title }}</span>
			        <span class="zixun-item-time">{{
			            item.creaTime.time | dateFormat
			        }}</span>
			    </div>
			</div>
            <!-- 智富学人 -->
            <div class="item-box clearfix">
                <div class="item-title flex-row">
                    <h2>{{ $store.state.navlist[56] }}</h2>
                    <a
                        href="javascript:void(0);"
                        class="titleA"
                        @click="
                            goList(
                                56,
                                $store.state.navlist[5],
                                $store.state.navlist[56]
                            )
                        "
                        >更多&gt;&gt;</a
                    >
                </div>
                               <div
                   @click="
                       goDetail(
                           item,
                           $store.state.navlist[5] +
                               '<' +
                               $store.state.navlist[56]
                       )
                   "
                   v-for="(item, index) in itemDataTwo"
                   :key="index"
                   class="zixun-item flex-row"
               >
                   <span class="zixun-title">{{ item.title }}</span>
                   <span class="zixun-item-time">{{
                       item.creaTime.time | dateFormat
                   }}</span>
               </div>
            </div>
        
           
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
    name: "lnjy",
    data() {
        return {
            itemDataOne: {},//简介51
            itemDataTwo: {},//智富学人56
            itemDataThree: [],//实用技术培训53
            itemDataFour: [],//农民中专54
			itemDataFive: [],//政策法规52
			itemDataSix: [],//镇村活动55
        };
    },
    created() {
        // 简介
        this.getZixunData(51);
        // 智富学人
        this.getZixunData(56);
        // 实用技术培训
        this.getZixunData(53);
        // 农民中专
        this.getZixunData(54);
		// 政策法规
		this.getZixunData(52);
		// 镇村活动
		this.getZixunData(55);
    },
    methods: {
        goList(navId, titleOne, titleTwo) {
            this.$router.push({
                name: "articalList",
                query: {
                    id: navId,
                    t1: titleOne,
                    t2: titleTwo
                }
            });
        },
        goDetail(item, title, titleTwo = "") {
            this.$router.push({
                name: "artDetail",
                query: {
                    id: item.id,
                    t1: title,
                    t2: titleTwo ? titleTwo : ""
                }
            });
        },
        getZixunData(navId, page = 1) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    navigationId: navId,
                    curren: page
                },
                success: res => {
                    if (res.code == 200) {
                        res.message.records.length > 5
                            ? (res.message.records.length = 5)
                            : res.message.records;
                        switch (navId) {
                            case 51:
                                this.itemDataOne = res.message.records[0]
                                    ? res.message.records[0]
                                    : {};
                                break;
                            case 56:
                                this.itemDataTwo = res.message.records;
                                break;
                            case 53:
                                this.itemDataThree = res.message.records;
                                break;
                            case 54:
                                this.itemDataFour = res.message.records;
                                break;
							case 52:
								this.itemDataFive = res.message.records;
								break;
							case 55:
								this.itemDataSix = res.message.records;
								break;	 
                            default:
                                break;
                        }
                    }
                }
            });
        }
    }
};
</script>
<style scoped="scoped" lang="scss">
.content {
    width: 1000px;
    margin: 0 auto;
    min-height: 500px;
    margin-top: 40px;
    align-items: flex-start;
    align-content: flex-start;
}
/* 图文盒子 */
.item-box:nth-child(odd) {
    margin-right: 60px;
}
.item-box {
    width: 470px;
    margin-bottom: 50px;
    margin-right: 0;
    border: 0;
    display: inline-block;
    position: relative;
    .item-title {
        color: #595959;
        height: 40px;
        padding: 0;
        justify-content: space-between;
        border-bottom: 2px solid #ddd;
        margin-bottom: 10px;
        h2 {
            position: relative;
            height: 20px;
            line-height: 20px;
            padding: 10px 0;
            border-bottom: 2px solid #6ac0e8;
            display: inline-block;
            z-index: 1;
            font-size: 18px;
            font-weight: bold;
        }
        a {
            line-height: 40px;
            font-size: 16px;
            color: #6ac0e8;
        }
    }
    // 图文信息
    .item-tw-img {
        width: 158px;
        height: 185px;
        float: left;
        margin: 5px 0;
        border: 1px solid #ddd;
        box-sizing: border-box;
        transition: all ease 0.3s;
        overflow: hidden;
        img {
            width: 100%;
            min-height: 100%;
            overflow: hidden;
        }
    }
    .item-tw-img:hover {
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    }
    .item-tw-text {
        width: 300px;
        height: 185px;
        float: right;
        margin: 5px 0;
        overflow: hidden;
        line-height: 23px;
    }
    // 信息
    .zixun-item {
        justify-content: space-between;
        cursor: pointer;
        .zixun-title {
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 5px 0;
            flex: 1;
            overflow: hidden;
        }
        .zixun-item-time {
            float: right;
            font-size: 14px;
            color: #999;
        }
    }
    .zixun-item:hover > .zixun-item-time {
        color: #333 !important;
    }
    .zixun-item:hover > .zixun-title {
        color: #333 !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/nmjy/nmjy.vue